<template>
  <div class="party-food">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <div class="bg"></div>
      <div class="center">
        <h1>{{ $t("message.party.h") }}</h1>
        <h3>{{ $t("message.party.p") }}</h3>
        <menubtn></menubtn>
      </div>
    </div>
    <!-- 内容 -->
    <div class="party-c">
      <!-- SEO -->
      <div class="center">
        <div class="seo">
          <div class="seo-show">
            <div>
              <img src="../assets/images/child.png" alt width="100%" height="100%"/>
            </div>
            <div>
              <h2>~{{ $t("message.party.contenth1") }}~</h2>
              <p>{{ $t("message.party.contentspan1") }}</p>
            </div>
          </div>
        </div>
        <div class="seo">
          <div class="seo-show">
            <div>
              <img src="../assets/images/menu3.png" alt width="100%" height="100%"/>
            </div>
            <div>
              <h2>~{{ $t("message.party.contenth2") }}~</h2>
              <p>{{ $t("message.party.contentspan2") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="center">
        <h2>~{{ $t("message.party.lasth1") }}~</h2>
        <button class="Btn" @click="open">{{ $t("message.party.btn") }}</button>
      </div>
    </div>
    <div class="activity-contanier">
      <div class="activity-main">
        <Title :title="$t('message.party.context.h2TitleOne')"></Title>
        <Content :content="$t('message.party.context.pContentOne')"></Content>
      </div>
    </div>
    <div class="activity-contanier">
      <div class="activity-main">
        <Title :title="$t('message.party.context.h2TitleSecond')"></Title>
        <Content :content="$t('message.party.context.pContentSecond')"></Content>
      </div>
    </div>
    <div class="faq-contanier">
      <div class="faq-main">
        <Title :title="$t('message.party.aboutPartyTitle')"></Title>
        <div class="feq-content">
          <div class="about-food-main">
            <div v-for="item in 3" :key="item" style="margin-left:10px">
              <h3 style="color: #000">{{ $t(`message.party.aboutParty.faq${item}`) }}</h3>
              <div style="margin-left:10px" class="feq-content-text">
                {{ $t(`message.party.aboutParty.content${item}`) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import header from "../components/header";
import menubtn from "../components/menubtn";
import Title from './common/title.vue'
import Content from './common/content.vue'

export default {
  name: "caterers",
  data() {
    return {};
  },
  methods: {
    open() {
      window.open("https://cateraway.rakosell.com/zh/products");
    },
  },
  components: {
    "v-header": header,
    menubtn,
    Title,
    Content
  },
};
</script>
<style lang="less" scoped>
.noneImg {
  opacity: 0;
}

.center {
  width: 75%;
  margin: auto;
}

/* 广告 */
.party-food .banner {
  position: relative;
  width: 100%;
  height: 600px;
  background: url("../assets/images/PartyHeroBanner.jpg") no-repeat;
  background-size: 100% 100%;
  margin: 100px 0 0 0;
}

.party-food .banner h1,
.party-food .banner h3 {
  text-align: center;
  color: white;
  font-weight: 500;
}

.party-food .banner h1 {
  font-size: 50px;
}

.party-food .banner h3 {
  margin: 1% 0;
  font-size: 2vw;
}

.party-food .banner .center {
  width: 90%;
  height: 40%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}

.party-food .banner .banner-call1 {
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}

.party-food .seo {
  margin: 2% 0;
  overflow: hidden;
}

.party-food .seo-show {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: center;
}

.party-food .seo h2 {
  text-align: center;
  color: #eb6410;
  font-weight: 300;
  margin-top: 2%;
  margin-bottom: 2%;
}

.party-food .seo-show > div:nth-child(1) {
  flex: 0 0 25%;
}

.party-food .seo-show > div:nth-child(2) {
  flex: 0 0 70%;
}

.party-c {
  padding: 2% 0;
}

.party-c h2 {
  text-align: center;
  color: #eb6410;
  font-weight: 300;
}

.party-c .Btn {
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 0.6em;
  border-radius: 4px;
  border: 0px;
  background-color: #eb6410;
  color: white;
  margin-top: 1rem;
  width: 10rem;
  cursor: pointer;
}

@media (max-width: 1350px) {
  .party-food .party-c .center {
    width: 90%;
  }
}

@media (max-width: 1150px) {
  .party-food .seo-show > div:nth-child(1),
  .party-food .seo-show > div:nth-child(2) {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }

  .noneImg {
    display: none;
  }
}

@media (max-width: 820px) {
  .party-food .party-food .banner .el-button.el-button--success {
    width: 60%;
  }

  .party-food .banner h1 {
    font-size: 25px;
  }

  .party-food .banner {
    margin-top: 135px;
    height: 300px;
  }

  /* seo */
  .party-food .seo h1 {
    font-size: 1.4rem;
    margin: 3% 0;
  }

  .party-food .seo p {
    width: 100%;
    font-weight: 400;
    padding: 0 3%;
    box-sizing: border-box;
  }

  .party-food .center {
    width: 100%;
  }

  .party-food .seo-show > div {
    width: 100%;
    position: static;
    top: 0;
    transform: translateY(0);
    float: none;
  }

  .party-food .seo img {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .party-food .banner {
    height: 240px;
  }
}
.activity-contanier {
  background-image: url("../assets/images/bodybg.jpg");
  background-size: 100% 100%;

  .activity-main {
    width: 70%;
    padding: 3% 2%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .activity-content-main {
      display: flex;
      justify-content: space-around;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .activity-item ~ .activity-item {
        margin-left: 30px;
        @media (max-width: 768px) {
          margin-left: 0px;
        }
      }

      .activity-item {
        text-align: center;
        flex: 0 0 30%;
        @media (max-width: 768px) {
          flex: 0 0 48%;
        }
        @media (max-width: 480px) {
          flex: 0 0 100%;
          display: flex;
          margin-bottom: 3%;
          text-align: left;
        }

        .activity-item-img {
          .item-img {
            width: 100%;
            height: 100%;
          }

          @media (max-width: 480px) {
            flex: 0 0 48%;
          }
        }

        .activity-item-content, .activity-item-span {
          margin: 20px;
        }

        .activity-item-content {
          font-size: 1.2vw;
          font-weight: 550;
        }

        .activity-item-span {
          font-size: 13px;
          color: #919599;
          font-weight: 350;
        }

        .item-button {
          @media (max-width: 480px) {
            margin: 0 20px;
          }
        }
      }
    }
  }
}
.faq-contanier {
  .faq-main {
    width: 70%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .feq-content {
      margin: 0 0 3%;
      font-size: .825rem;
      color: #919599;

      .feq-content-text {
        margin-bottom: 3%;
      }
    }

  }
}
</style>
<style>
.party-food .banner .el-button.el-button--success {
  display: block;
  width: 100%;
  margin: 0;
  background: #eb6410;
  border: 1px solid #eb6410;
}

.party-food .banner .el-dialog {
  margin-top: 12vh !important;
}

.party-food .banner .el-dialog__body {
  padding: 0 33px 0 0 !important;
}

.party-food .el-scrollbar__view.el-time-spinner__list li,
.el-scrollbar__view.el-select-dropdown__list li {
  display: block;
}
</style>
